module.exports = __webpack_public_path__ + "img/angular-material-stencil.a2a66476.svg";